module.exports = __webpack_public_path__ + "img/homepage-quick-links-boxes-arrows-infiniti.f053d59b.png";